import { ChangeDetectorRef, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';
import { SelectBaseComponent } from 'src/app/shared-feature/components/select/select-base';

@Component({
  selector: 'app-tax-code-multi-select',
  templateUrl: './tax-code-multi-select.component.html',
  styles: [
    `
      :host ::ng-deep .ant-select-clear {
        right: 40px !important;
      }
      :host
        ::ng-deep
        .ant-select-multiple.ant-select-allow-clear
        .ant-select-selector {
        padding-right: 50px !important;
      }
    `
  ],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TaxCodeMultiSelectComponent),
      multi: true
    }
  ]
})
export class TaxCodeMultiSelectComponent extends SelectBaseComponent {
  constructor(http: _HttpClient, cdr: ChangeDetectorRef) {
    super(http, cdr);
  }

  get taxList() {
    return this.list.filter((o: any) => o.id);
  }

  getUrl(searchValue: string): string {
    return `api/taxcodes/alltax/query?$orderby=code asc&$top=50&$skip=0&$filter=(contains(code, '${encodeURIComponent(
      searchValue
    )}'))`;
  }
}

